import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {config} from "@commons/config.instance";

interface File {
    file: string
}

export const uploadRetribuzioniApi = createApi({
    reducerPath: 'uploadRetribuzioniApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['uploadRetribuzioni'],
    endpoints: (builder) => ({

        // http://fpnet.local/FPNet2021/servizio/67-68/upload/rml?auth_token=9854c3cf4d6c502869f5044845a1f9bc
        uploadFile: builder.mutation<{ size: number }, { formData: FormData, idAziendaMaster: number, idAzienda: number }>({
            query: ({formData, idAziendaMaster, idAzienda}) => ({
                url: `/servizio/${idAziendaMaster}-${idAzienda}/upload/rml`,
                method: 'POST',
                body: formData,
            }),
        }),

    }),
})
export const {useUploadFileMutation} = uploadRetribuzioniApi;